import api from "@/api";
import utilities from "@/helpers/utilities";
import i18n from "@/i18n";

const state = {
    persons: [],
    person: {}
};

const mutations = {
    setPersons(state, persons) {
        state.persons = persons;
    },
    setPerson(state, person) {
        state.person = person;
    }
};

const actions = {
    async fetchPerson({ commit }, id) {
        const response = await api.persons.fetch(id);
        commit("setPerson", response.data);
    },
    async loadPersons({ commit }) {
        const response = await api.persons.list();
        commit("setPersons", response.data);
    },
    async savePerson({ dispatch, state }, form) {
        const response = await api.persons.save(form);
        await dispatch("fetchPerson", response.data.id);
        await dispatch("updateProfile", state.person);
    },
    async saveOrUpdatePerson({ dispatch }, form) {
        if (utilities.isEmptyOrZero(form.id)) {
            await dispatch("savePerson", form);
        } else {
            await dispatch("updatePerson", form);
        }

        await dispatch("loadPersons");
        dispatch("showSuccess", i18n.t("message.success.saved"));
    },
    async updatePerson({ dispatch, getters }, form) {
        await api.persons.update(form.id, form);
        if (getters.profile.person.id === form.id) {
            await dispatch("fetchPerson", form.id);
            await dispatch("updateProfile", getters.person);
        }
        await dispatch("loadDemands");
    }
};

const getters = {
    person(state) {
        return state.person;
    },
    persons(state) {
        const persons = state.persons || [];
        return persons.sort((a, b) => utilities.stringCompare(a.name, b.name));
    },
    personsHired(_, getters) {
        return getters.persons.filter(person => person.isHired);
    },
    personsNotHired(_, getters) {
        return getters.persons.filter(person => !person.isHired);
    },
    personsValueText(_, getters) {
        return getters.persons
            .filter(person => {
                if (!getters.profile.office) return person.isActive;
                return (
                    person.isActive &&
                    !!person.area &&
                    person.office.id === getters.profile.office
                );
            })
            .map(({ id, username, name }) => ({
                value: id,
                text: `${username} - ${name}`
            }));
    },
    personsHiredValueText(_, getters) {
        return getters.personsHired
            .filter(person => person.isActive)
            .map(({ id, username, name }) => ({
                value: id,
                text: `${username} - ${name}`
            }));
    },
    personsNotHiredValueText(_, getters) {
        return getters.personsNotHired
            .filter(person => person.isActive)
            .map(({ id, username, name }) => ({
                value: id,
                text: `${username} - ${name}`
            }));
    },
    personsNotHiredSomeOfficeProfileValueText(_, getters) {
        return getters.personsNotHired
            .filter(
                person =>
                    person.isActive &&
                    !!person.office &&
                    person.office.id === getters.profile.office
            )
            .map(({ id, username, name }) => ({
                value: id,
                text: `${username} - ${name}`
            }));
    },
    personsDictionary(_, getters) {
        return getters.persons.reduce((map, obj) => {
            map[obj.id] = obj;
            return map;
        }, {});
    }
};

export default {
    state,
    mutations,
    actions,
    getters
};



// WEBPACK FOOTER //
// ./src/store/modules/persons.js